import { faPause, faPlay, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactElement, useState } from 'react';
import VoxelIconButton from '../../components/voxel/Buttons/VoxelIconButton';
import VoxelChip from '../../components/voxel/Chips/VoxelChip';
import VoxelDataTable from '../../components/voxel/DataTable/VoxelDataTable';
import VoxelDataTableBody from '../../components/voxel/DataTable/VoxelDataTableBody';
import VoxelDataTableCell from '../../components/voxel/DataTable/VoxelDataTableCell';
import VoxelDataTableHead from '../../components/voxel/DataTable/VoxelDataTableHead';
import VoxelDataTableHeadCell from '../../components/voxel/DataTable/VoxelDataTableHeadCell';
import VoxelDataTableRow from '../../components/voxel/DataTable/VoxelDataTableRow';
import SearchCommandsInfo from '../../components/voxel/Search/SearchCommandsInfo';
import VoxelAdvancedTextSearch from '../../components/voxel/Search/VoxelAdvancedTextSearch';
import VoxelPanel from '../../components/voxel/Surfaces/VoxelPanel';
import VoxelTable from '../../components/voxel/Tables/VoxelTable';
import VoxelTableCell from '../../components/voxel/Tables/VoxelTableCell';
import VoxelTableHeadCell from '../../components/voxel/Tables/VoxelTableHeadCell';
import VoxelTableRow from '../../components/voxel/Tables/VoxelTableRow';
import VoxelText from '../../components/voxel/Text/VoxelText';
import VoxelTrendChip from '../../components/voxel/Chips/VoxelTrendChip';

export interface TablesBoardProps { }

interface TableItem {
  item: any,
  align: "center" | "left" | "right" | "justify" | "char",
}

export const TablesBoard: React.FC<TablesBoardProps> = ({ }) => {

  const [searchTerm, setSearchTerm] = useState<string>('');


  const inlineButtons: ReactElement =
    <div className='flex flex-row justify-end'>
      <VoxelIconButton
        tooltip="Pause"
        containerType="table"
        icon={<FontAwesomeIcon icon={faPause} />}
        size="sm"
        color="white"
        onClick={() => { }}
      />
      <VoxelIconButton
        tooltip="Resume"
        containerType="table"
        size="sm"
        color="white"
        onClick={() => { }}
        icon={<FontAwesomeIcon icon={faPlay} />}
      />
      <VoxelIconButton
        tooltip={'Delete'}
        containerType="table"
        size="sm"
        color="white"
        onClick={() => { }}
        icon={<FontAwesomeIcon icon={faTrash} />}
      />
    </div>;
  const tableHeadData: TableItem[] = [
    { item: 'Search type', align: 'left' },
    { item: 'Name', align: 'left' },
    { item: 'Create time', align: 'center' },
    { item: 'Status', align: 'center' },
    { item: 'Keywords', align: 'right' },
    { item: 'Trend', align: 'right' },
    { item: '', align: 'right' },
  ];

  const tableBodyData: TableItem[][] =
    [[
      { item: 'Related', align: 'left' },
      { item: 'skor...', align: 'left' },
      { item: '2024-12-11', align: 'center' },
      { item: <VoxelChip color='success' title={'approved'} size='sm' />, align: 'center' },
      { item: 469, align: 'right' },
      { item: <VoxelTrendChip color='success' title={'+7%'} size='xs' />, align: 'right' },
      { item: inlineButtons, align: 'right' },
    ], [
      { item: 'Related', align: 'left' },
      { item: 'skor...', align: 'left' },
      { item: '2024-12-11', align: 'center' },
      { item: <VoxelChip color='error' title={'disapproved'} size='sm' />, align: 'center' },
      { item: 469, align: 'right' },
      { item: <VoxelTrendChip color='success' title={'+2156%'} size='xs' />, align: 'right' },
      { item: inlineButtons, align: 'right' },
    ], [
      { item: 'Related', align: 'left' },
      { item: 'skor...', align: 'left' },
      { item: '2024-12-11', align: 'center' },
      { item: <VoxelChip color='warning' title={'pending'} size='sm' />, align: 'center' },
      { item: 469, align: 'right' },
      { item: <VoxelTrendChip color='neutral' title={'0%'} size='xs' />, align: 'right' },
      { item: inlineButtons, align: 'right' },
    ], [
      { item: 'Related', align: 'left' },
      { item: 'skor...', align: 'left' },
      { item: '2024-12-11', align: 'center' },
      { item: <VoxelChip color='info' title={'pending'} size='sm' />, align: 'center' },
      { item: 469, align: 'right' },
      { item: <VoxelTrendChip color='error' title={'-33%'} size='xs' />, align: 'right' },
      { item: inlineButtons, align: 'right' },
    ], [
      { item: 'Related', align: 'left' },
      { item: 'skor...', align: 'left' },
      { item: '2024-12-11', align: 'center' },
      { item: <VoxelChip color='neutral' title={'pending'} size='sm' />, align: 'center' },
      { item: 469, align: 'right' },
      { item: <VoxelTrendChip color='warning' title={'-3%'} size='xs' />, align: 'right' },
      { item: inlineButtons, align: 'right' },
    ]];

  return (
    <div className='flex flex-col gap-12'>
      <div>
        <VoxelText variant='title2' paddingBot>Voxel table</VoxelText>
        <VoxelPanel>
          <div className='p-2'>
            <VoxelAdvancedTextSearch
              size='sm'
              widthClass='w-64'
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
              infoIcon={<SearchCommandsInfo />}
              deleteValue={() => setSearchTerm('')} />
          </div>
          <VoxelTable>
            <thead>
              <VoxelTableRow>
                {tableHeadData.map(d => (
                  <VoxelTableHeadCell align={d.align}>{d.item}</VoxelTableHeadCell>
                ))}
              </VoxelTableRow>
            </thead>
            <tbody>
              {tableBodyData.map(row => (
                <VoxelTableRow button onClick={() => undefined}>
                  {row.map(d => (
                    <VoxelTableCell align={d.align}>{d.item}</VoxelTableCell>
                  ))}
                </VoxelTableRow>
              ))}
            </tbody>
          </VoxelTable >
        </VoxelPanel>
      </div>
      <div>
        <VoxelText variant='title2' paddingBot>Voxel data table</VoxelText>
        <VoxelPanel className='w-full'>
          <div className='p-2'>
            <VoxelAdvancedTextSearch size='sm' widthClass='w-64' value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} deleteValue={() => setSearchTerm('')} />
          </div>
          <VoxelDataTable className='w-full'>
            <VoxelDataTableHead>
              <VoxelDataTableRow>
                {tableHeadData.map(d => (
                  <VoxelDataTableHeadCell align={d.align}>{d.item}</VoxelDataTableHeadCell>
                ))}
              </VoxelDataTableRow>
            </VoxelDataTableHead>
            <VoxelDataTableBody>
              {tableBodyData.map(row => (
                <VoxelTableRow button onClick={() => undefined}>
                  {row.map(d => (
                    <VoxelDataTableCell align={d.align}>{d.item}</VoxelDataTableCell>
                  ))}
                </VoxelTableRow>
              ))}
            </VoxelDataTableBody>
          </VoxelDataTable >
        </VoxelPanel>
      </div>
    </div>
  );
};

export default TablesBoard;
